import { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { MultiSelectDropdown } from '@repo/ui/OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '@repo/ui/OffersFilter/useFilterEvents';
import { shallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../store';
import { useFilterProductTypeOptions } from '../store/hooks';

export const ProductTypeSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  regionCode,
  isBankBonusesFilterExperiment,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  regionCode?: StateAbbreviation;
  isBankBonusesFilterExperiment?: boolean;
}) => {
  const productTypeOptions = useFilterProductTypeOptions(regionCode);
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleProductTypeChange = (selectedLabels: string[]) => {
    if (scrollBackToMainBar) {
      scrollBackToMainBar();
    }

    setTimeout(
      () => {
        handleUpdateFilterFormState({
          selectedProductTypes: selectedLabels,
        });

        const newState = handleApplyFilters();
        if (!newState) return;

        updateFiltersEvent({
          additional_attributes: {
            product_types: selectedLabels,
            location: newState.appliedFilters.selectedLocation,
          },
        });
      },
      scrollBackToMainBar ? 100 : 0,
    );
  };

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Product Type"
      options={productTypeOptions}
      selectedOptions={appliedFilters?.selectedProductTypes || []}
      onChange={handleProductTypeChange}
      useStore={useOffersFilterStore}
      isBankBonusesFilterExperiment={isBankBonusesFilterExperiment}
    />
  );
};
